module.exports = __webpack_public_path__ + "newsTitle_ad.6287110b.jpg";